/* Zimmer6 theme – vanilla JS, no dependencies */
(function () {
  'use strict';

  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  var theme = window.theme || {};

  /* ---------------- Money ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || theme.moneyFormat || '${{amount}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match && match[1]) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }

  /* ---------------- Toast ---------------- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3000);
  }

  /* ---------------- Overlay / drawers ---------------- */
  var overlay = $('[data-overlay]');
  // Drawers rendered inside the sticky header inherit its stacking context and end up
  // beneath the overlay (taps hit the overlay). Move them to <body> so z-index works.
  $$('.section-header [data-drawer]').forEach(function (d) { document.body.appendChild(d); });
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-drawer]', e.target).forEach(function (d) {
      var old = $$('body > [data-drawer="' + d.dataset.drawer + '"]').filter(function (x) { return x !== d; });
      old.forEach(function (x) { x.remove(); });
      document.body.appendChild(d);
    });
  });
  var openLayer = null;

  function lock(on) { document.body.classList.toggle('is-locked', on); }

  function openDrawer(name) {
    var drawer = $('[data-drawer="' + name + '"]');
    if (!drawer) return false;
    closeAll();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    lock(true);
    openLayer = drawer;
    var focusable = drawer.querySelector('button, a, input');
    if (focusable) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 250);
    return true;
  }

  function closeAll() {
    $$('.drawer.is-open, .search-modal.is-open, .modal.is-open').forEach(function (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    if (overlay) overlay.hidden = true;
    lock(false);
    openLayer = null;
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close], [data-modal-close], [data-search-close]') || e.target === overlay) { closeAll(); return; }
    var modalOpener = e.target.closest('[data-modal-open]');
    if (modalOpener) {
      var modal = document.getElementById(modalOpener.getAttribute('data-modal-open'));
      if (modal) { closeAll(); modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); lock(true); }
      return;
    }
    if (e.target.classList && e.target.classList.contains('modal')) closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------------- Header ---------------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Announcement rotation ---------------- */
  $$('[data-announcement]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, (parseInt(bar.dataset.speed, 10) || 5) * 1000);
  });

  /* ---------------- Cart ---------------- */
  var Cart = {
    sections: function () {
      var ids = ['cart-drawer'];
      return ids;
    },
    request: function (url, body) {
      var opts = { method: 'POST', headers: { Accept: 'application/json' } };
      if (body instanceof FormData) {
        opts.body = body;
      } else {
        opts.headers['Content-Type'] = 'application/json';
        opts.body = JSON.stringify(body);
      }
      return fetch(url, opts).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw data;
          return data;
        });
      });
    },
    renderDrawer: function (html) {
      var current = $('#CartDrawer');
      if (!current || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      if (fresh) current.innerHTML = fresh.innerHTML;
    },
    refresh: function () {
      return fetch(theme.routes.root + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) { Cart.renderDrawer(data['cart-drawer']); })
        .then(Cart.updateCount);
    },
    updateCount: function (count) {
      var p = typeof count === 'number' ? Promise.resolve(count) : fetch(theme.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { return c.item_count; });
      return p.then(function (n) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
        var c = $('.cart-drawer__count'); if (c) c.textContent = '(' + n + ')';
      });
    },
    open: function () {
      if (theme.cartType === 'drawer' && $('#CartDrawer')) openDrawer('cart');
      else window.location.href = theme.routes.cart;
    },
    change: function (line, quantity, itemEl) {
      if (itemEl) itemEl.classList.add('is-loading');
      var onPage = !!$('[data-cart-page]');
      return Cart.request(theme.routes.cartChange + '.js', { line: line, quantity: quantity, sections: Cart.sections(), sections_url: window.location.pathname })
        .then(function (cart) {
          if (onPage) { window.location.reload(); return; }
          Cart.renderDrawer(cart.sections && cart.sections['cart-drawer']);
          Cart.updateCount(cart.item_count);
        })
        .catch(function (err) {
          if (itemEl) itemEl.classList.remove('is-loading');
          toast((err && (err.description || err.message)) || 'Could not update cart');
        });
    }
  };
  window.ThemeCart = Cart;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener && theme.cartType === 'drawer' && $('#CartDrawer') && !$('[data-cart-page]')) {
      e.preventDefault();
      Cart.open();
      return;
    }
    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      var item = qtyBtn.closest('[data-line]');
      Cart.change(parseInt(item.dataset.line, 10), Math.max(0, parseInt(qtyBtn.dataset.cartQty, 10)), item);
    }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cart-qty-input]')) {
      var item = e.target.closest('[data-line]');
      Cart.change(parseInt(item.dataset.line, 10), Math.max(0, parseInt(e.target.value, 10) || 0), item);
    }
  });

  /* Some apps (bundles/upsells) add to cart themselves and fire these events. */
  ['cart:refresh', 'cart:updated', 'theme:cart:refresh'].forEach(function (evt) {
    document.addEventListener(evt, function () { Cart.refresh(); });
  });

  /* ---------------- Product form ---------------- */
  function initProductForm(form) {
    form.addEventListener('submit', function (e) {
      if (theme.cartType !== 'drawer' || !$('#CartDrawer')) return; // normal submit → /cart
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart]');
      var errorEl = form.querySelector('[data-form-error]');
      if (btn.disabled) return;
      btn.classList.add('is-loading');
      if (errorEl) errorEl.hidden = true;
      var fd = new FormData(form);
      fd.append('sections', Cart.sections().join(','));
      fd.append('sections_url', window.location.pathname);
      Cart.request(theme.routes.cartAdd + '.js', fd)
        .then(function (item) {
          Cart.renderDrawer(item.sections && item.sections['cart-drawer']);
          Cart.updateCount();
          Cart.open();
          document.dispatchEvent(new CustomEvent('theme:cart:added', { detail: item }));
        })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || 'Could not add to cart';
          if (typeof msg === 'object') msg = Object.values(msg).join(' ');
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } else toast(msg);
        })
        .finally(function () { btn.classList.remove('is-loading'); });
    });
  }

  /* ---------------- Quantity bundles (Buy 1 / 2 / 3) ---------------- */
  $$('[data-qb]').forEach(function (qb) {
    var section = qb.closest('[data-product]');
    var form = section && $('[data-product-form]', section);
    if (!form) return;
    var variants = JSON.parse($('[data-qb-variants]', qb).textContent);
    var freeShip = parseInt(qb.dataset.freeShip, 10) || 0;
    var unitCompare = parseInt(qb.dataset.unitCompare, 10) || 0;
    var addons = $('[data-qb-addons]', qb);
    // Optional: offer add-ons only with one option (e.g. the free-shipping bundle), never next to paid shipping
    function addonsAllowed() {
      var only = addons ? parseInt(addons.dataset.tier, 10) || 0 : 0;
      return !only || tiers.indexOf(chosen()) === only - 1;
    }
    var money = function (c) { return formatMoney(c, theme.moneyFormat); };
    var tiers = $$('[data-qb-tier]', qb);
    var qtyBox = $('.qty', form), qtyInput = $('[name="quantity"]', form);
    if (qtyBox) qtyBox.hidden = true; // quantity comes from the chosen bundle
    function byId(id) { id = parseInt(id, 10); return variants.filter(function (v) { return v.id === id; })[0] || variants[0]; }
    function byOptions(opts) { return variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0]; }
    function current() { return byId($('[data-variant-id]', form).value); }
    function pickVariant(pick) { return byOptions($$('[data-qb-opt]', pick).map(function (s) { return s.value; })); }
    function picks(tier) {
      var rows = $$('[data-qb-pick]', tier);
      if (rows.length) return rows.map(pickVariant);
      // No design rows (single-variant product): the tier is N of the current variant.
      var n = parseInt(tier.dataset.qty, 10) || 1, list = [];
      for (var i = 0; i < n; i++) list.push(current());
      return list;
    }
    function setPick(pick, v) { $$('[data-qb-opt]', pick).forEach(function (s, i) { s.value = v.options[i]; }); }
    function render() {
      tiers.forEach(function (tier) {
        var pct = parseFloat(tier.dataset.pct) || 0, list = picks(tier), bad = list.some(function (v) { return !v || !v.available; });
        $$('[data-qb-pick]', tier).forEach(function (row) {
          var v = pickVariant(row), img = $('[data-qb-thumb]', row);
          row.classList.toggle('is-bad', !v || !v.available);
          if (v && img && v.img && img.getAttribute('src') !== v.img) img.src = v.img;
        });
        var total = list.reduce(function (sum, v) { return sum + (v ? v.price : 0); }, 0);
        total = tier.dataset.bundlePrice ? parseInt(tier.dataset.bundlePrice, 10) : Math.round(total * (100 - pct) / 100);
        var full = unitCompare ? unitCompare * list.length : list.reduce(function (sum, v) { return sum + (v ? v.price : 0); }, 0);
        $('[data-qb-total]', tier).textContent = money(total);
        $$('[data-qb-sub]', tier).forEach(function (el) {
          el.textContent = el.dataset.tpl.replace('[pct]', full > total ? Math.round((full - total) * 100 / full) : 0);
        });
        var cmp = $('[data-qb-compare]', tier); if (cmp) cmp.textContent = money(full);
        var save = $('[data-qb-save]', tier); if (save) save.textContent = 'Save ' + money(full - total);
        $('[data-qb-ship]', tier).hidden = !(freeShip && total >= freeShip);
        var on = $('input[type=radio]', tier).checked;
        tier.classList.toggle('is-on', on);
        if (on) tier.dataset.bad = bad ? '1' : '';
      });
      var btn = $('[data-add-to-cart]', form), t = chosen();
      if (btn && t) btn.toggleAttribute('data-qb-unavailable', t.dataset.bad === '1');
      if (addons && t && t.nextElementSibling !== addons) t.after(addons); // add-ons sit under the chosen option
      if (addons) addons.hidden = !addonsAllowed();
    }
    function chosen() { return tiers.filter(function (t) { return $('input[type=radio]', t).checked; })[0] || tiers[0]; }
    qb.addEventListener('click', function (e) { if (e.target.closest('select')) e.stopPropagation(); }, true);
    qb.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-qb-opt]');
      if (sel) {
        // first row mirrors the main picker so the gallery follows the customer's pick
        var row = sel.closest('[data-qb-pick]'), tier = row.closest('[data-qb-tier]');
        if ($$('[data-qb-pick]', tier)[0] === row) {
          var input = $('[data-option-index="' + sel.dataset.qbOpt + '"] [data-option-input][value="' + CSS.escape(sel.value) + '"]', section) || $('[data-option-input][value="' + CSS.escape(sel.value) + '"]', section);
          if (input && !input.checked) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
        }
      }
      render();
    });
    section.addEventListener('variant:change', function (e) {
      var v = e.detail && e.detail.variant; if (!v) return;
      tiers.forEach(function (t) { var r = $('[data-qb-pick]', t); if (r) setPick(r, byId(v.id)); });
      render();
    });
    // Buy 2 / Buy 3 (or any option with a bundle product or ticked add-ons): add everything in one request;
    // a plain Buy 1 falls through to the normal form submit.
    form.addEventListener('submit', function (e) {
      var tier = chosen(), qty = parseInt(tier.dataset.qty, 10) || 1;
      if (qtyInput) qtyInput.value = 1;
      var extras = $$('[data-qb-addon]', qb).filter(function (i) { return i.checked && addonsAllowed(); }).map(function (i) { return { id: parseInt(i.value, 10), quantity: 1 }; });
      // ticked "You may also like" products ride along with the same tap
      extras = extras.concat($$('[data-upsell]', section).filter(function (i) { return i.checked && !i.disabled; }).map(function (i) { return { id: parseInt(i.value, 10), quantity: 1 }; }));
      if (qty <= 1 && !tier.dataset.bundleVariant && !extras.length) return;
      e.preventDefault(); e.stopImmediatePropagation();
      var btn = $('[data-add-to-cart]', form), errorEl = $('[data-form-error]', form);
      if (btn.disabled || btn.classList.contains('is-loading')) return;
      var list = picks(tier);
      if (list.some(function (v) { return !v || !v.available; })) {
        var m = 'One of your picks is sold out — please choose another.';
        if (errorEl) { errorEl.textContent = m; errorEl.hidden = false; } else toast(m);
        return;
      }
      btn.classList.add('is-loading'); if (errorEl) errorEl.hidden = true;
      var items;
      if (tier.dataset.bundleVariant) {
        // One bundle item at the bundle's own price; the picked designs travel as line item properties.
        var props = {};
        list.forEach(function (v, i) { if (v.options.join('') !== 'Default Title') props['Set ' + (i + 1)] = v.options.join(' / '); });
        items = [{ id: parseInt(tier.dataset.bundleVariant, 10), quantity: 1, properties: props }];
      } else {
        var counts = {};
        list.forEach(function (v) { counts[v.id] = (counts[v.id] || 0) + 1; });
        items = Object.keys(counts).map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      }
      // Add-ons are once per order: skip any that are already in the cart (e.g. a second bundle added later).
      fetch(theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .catch(function () { return { items: [] }; })
        .then(function (cart) {
          var have = (cart.items || []).map(function (li) { return li.variant_id; });
          items = items.concat(extras.filter(function (x) { return have.indexOf(x.id) === -1; }));
          return Cart.request(theme.routes.cartAdd + '.js', { items: items, sections: Cart.sections(), sections_url: window.location.pathname });
        })
        .then(function (res) {
          if (theme.cartType === 'drawer' && $('#CartDrawer')) {
            Cart.renderDrawer(res.sections && res.sections['cart-drawer']);
            Cart.updateCount(); Cart.open();
          } else { window.location.href = theme.routes.cart; }
          document.dispatchEvent(new CustomEvent('theme:cart:added', { detail: res }));
        })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || 'Could not add to cart';
          if (typeof msg === 'object') msg = Object.values(msg).join(' ');
          if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } else toast(msg);
        })
        .finally(function () { btn.classList.remove('is-loading'); });
    }, true);
    render();
  });
  $$('[data-product-form]').forEach(initProductForm);

  /* Quantity steppers on product page */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var input = (minus || plus).parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (plus ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Product: variants + gallery ---------------- */
  function initProduct(section) {
    var picker = $('[data-variant-picker]', section);
    var form = $('[data-product-form]', section);
    var gallery = $('[data-gallery]', section);
    var main = gallery && $('[data-gallery-main]', gallery);
    var thumbs = gallery ? $$('.gallery__thumb', gallery) : [];

    function goTo(index, smooth) {
      if (!main) return;
      var slide = main.children[index];
      if (!slide) return;
      main.scrollTo({ left: slide.offsetLeft - main.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      setActiveThumb(index);
    }
    function setActiveThumb(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); });
      var t = thumbs[index];
      if (t && t.parentElement) {
        var p = t.parentElement;
        p.scrollTo({ left: t.offsetLeft - p.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
      }
    }
    function currentIndex() {
      if (!main) return 0;
      return Math.round(main.scrollLeft / main.clientWidth);
    }
    if (gallery) {
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.thumbIndex, 10)); }); });
      var prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
      var count = main.children.length;
      if (prev) prev.addEventListener('click', function () { goTo((currentIndex() - 1 + count) % count); });
      if (next) next.addEventListener('click', function () { goTo((currentIndex() + 1) % count); });
      var scrollTimer;
      main.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () { setActiveThumb(currentIndex()); }, 80);
      }, { passive: true });
    }

    function goToMedia(mediaId) {
      if (!main || !mediaId) return;
      var slides = Array.prototype.slice.call(main.children);
      var idx = slides.findIndex(function (s) { return s.dataset.mediaId == mediaId; });
      if (idx > -1) goTo(idx);
    }

    // Swatch colors that aren't valid CSS colors fall back to grey
    $$('.swatch', section).forEach(function (sw) {
      var c = sw.style.getPropertyValue('--swatch').trim();
      if (c && window.CSS && !CSS.supports('color', c)) sw.style.setProperty('--swatch', '#cfcfcf');
    });

    if (!picker) return;
    var variants = JSON.parse($('[data-variants-json]', picker).textContent);
    var fieldsets = $$('.option', picker);

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function updateAvailability(opts) {
      fieldsets.forEach(function (fs, idx) {
        $$('input', fs).forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var ok = variants.some(function (v) { return v.available && v.options.every(function (o, i) { return i === idx ? o === input.value : (i < idx ? o === test[i] : true); }); });
          input.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function update() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, i) { var l = fs.querySelector('[data-option-value]'); if (l) l.textContent = opts[i]; });
      var variant = findVariant(opts);
      updateAvailability(opts);
      var btn = form && $('[data-add-to-cart]', form);
      var label = btn && $('[data-atc-label]', btn);
      if (!variant) {
        if (btn) { btn.disabled = true; label.textContent = 'Unavailable'; }
        return;
      }
      if (form) $('[data-variant-id]', form).value = variant.id;
      $$('form input[name="id"]', section).forEach(function (i) { i.value = variant.id; });
      if (btn) { btn.disabled = !variant.available; label.textContent = variant.available ? 'Add to cart' : 'Sold out'; }

      var priceEl = $('[data-price]', section);
      if (priceEl) {
        $('[data-price-current]', priceEl).textContent = formatMoney(variant.price);
        var cmp = $('[data-price-compare]', priceEl);
        var badge = $('[data-price-badge]', priceEl);
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        cmp.hidden = !onSale;
        cmp.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        if (badge) {
          badge.hidden = !onSale;
          if (onSale) badge.textContent = 'Save ' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
        }
      }
      var sp = $('[data-sticky-price]', section);
      if (sp) sp.textContent = formatMoney(variant.price);
      var sv = $('[data-sticky-variant]', section);
      if (sv) sv.textContent = variant.title;
      $$('[data-team-strip] [data-team]').forEach(function (a) { a.classList.toggle('is-active', a.dataset.team === variant.options[parseInt(a.closest('[data-team-strip]').dataset.optionIndex, 10)]); });

      if (variant.featured_media) goToMedia(variant.featured_media.id);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      section.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
    }

    picker.addEventListener('change', function (e) { if (e.target.matches('[data-option-input]')) update(); });
    updateAvailability(selectedOptions());
    var initial = findVariant(selectedOptions());
    if (initial && initial.featured_media && !(gallery && gallery.hasAttribute('data-start-featured'))) {
      var slides = Array.prototype.slice.call(main ? main.children : []);
      var idx = slides.findIndex(function (s) { return s.dataset.mediaId == initial.featured_media.id; });
      if (idx > 0) requestAnimationFrame(function () { goTo(idx, false); });
    }
  }
  $$('[data-product]').forEach(initProduct);

  /* Compact style picker (opt-in per template): show all / search */
  $$('[data-compact]').forEach(function (fs) {
    var toggle = $('[data-option-toggle]', fs), search = $('[data-option-search]', fs);
    var labels = $$('.img-option', fs);
    if (toggle) toggle.addEventListener('click', function () {
      var open = fs.classList.toggle('is-expanded');
      toggle.textContent = open ? toggle.dataset.labelLess : toggle.dataset.labelMore;
      if (!open) fs.scrollIntoView({ block: 'nearest' });
    });
    if (search) search.addEventListener('input', function () {
      var q = search.value.trim().toLowerCase();
      fs.classList.toggle('is-searching', !!q);
      labels.forEach(function (l) { l.classList.toggle('is-miss', !!q && (l.dataset.name || '').indexOf(q) === -1); });
    });
    // a style chosen from outside the first N (e.g. via ?variant=) stays visible
    fs.addEventListener('change', function (e) {
      var lab = e.target.id && fs.querySelector('label[for="' + e.target.id + '"]');
      labels.forEach(function (l) { l.classList.remove('is-pinned'); });
      if (lab && lab.classList.contains('is-extra')) lab.classList.add('is-pinned');
    });
  });

  /* Enlarged preview when hovering / tapping a variant image option */
  (function () {
    var options = $$('.img-option[data-preview]');
    if (!options.length) return;
    var pop = document.createElement('div');
    pop.className = 'img-preview';
    pop.setAttribute('aria-hidden', 'true');
    pop.innerHTML = '<img alt=""><span class="img-preview__label"></span>';
    document.body.appendChild(pop);
    var img = pop.querySelector('img'), label = pop.querySelector('.img-preview__label');
    var hideTimer, current = null;
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    // warm the cache so the popup appears instantly
    var warm = function () { options.forEach(function (o) { var i = new Image(); i.src = o.dataset.preview; }); };
    if ('requestIdleCallback' in window) requestIdleCallback(warm); else setTimeout(warm, 1500);

    function place(tile) {
      var r = tile.getBoundingClientRect();
      var w = pop.offsetWidth, h = pop.offsetHeight, gap = 12;
      var vw = document.documentElement.clientWidth, vh = window.innerHeight;
      var headerEl = document.querySelector('.section-header');
      var minTop = (headerEl ? Math.max(0, headerEl.getBoundingClientRect().bottom) : 0) + 8;
      var spaceAbove = r.top - gap - minTop, spaceBelow = vh - r.bottom - gap - 8;
      var side = spaceAbove >= h || spaceAbove >= spaceBelow ? 'top' : 'bottom';
      var top = side === 'top' ? r.top - h - gap : r.bottom + gap;
      var clamped = Math.min(Math.max(minTop, top), vh - h - 8);
      var left = Math.min(Math.max(8, r.left + r.width / 2 - w / 2), vw - w - 8);
      pop.style.top = clamped + 'px';
      pop.style.left = left + 'px';
      pop.style.setProperty('--arrow-x', (r.left + r.width / 2 - left) + 'px');
      pop.dataset.side = clamped === top ? side : 'none';
    }
    function show(tile, autoHide) {
      clearTimeout(hideTimer);
      current = tile;
      if (img.getAttribute('src') !== tile.dataset.preview) img.src = tile.dataset.preview;
      label.textContent = tile.dataset.previewLabel || '';
      pop.classList.add('is-visible');
      place(tile);
      if (!img.complete) img.onload = function () { if (current === tile) place(tile); };
      if (autoHide) hideTimer = setTimeout(hide, 2500);
    }
    function hide() { clearTimeout(hideTimer); current = null; pop.classList.remove('is-visible'); }

    options.forEach(function (tile) {
      if (finePointer) {
        tile.addEventListener('mouseenter', function () { show(tile, false); });
        tile.addEventListener('mouseleave', hide);
      }
      tile.addEventListener('click', function () { show(tile, !finePointer); });
    });
    window.addEventListener('scroll', function () { if (current) { finePointer ? place(current) : hide(); } }, { passive: true });
    document.addEventListener('touchstart', function (e) { if (current && !e.target.closest('.img-option')) hide(); }, { passive: true });
  })();

  /* Country / currency selector */
  $$('[data-loc]').forEach(function (loc) {
    var btn = $('[data-loc-toggle]', loc), panel = btn.nextElementSibling, search = $('[data-loc-search]', loc);
    function close() { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); }
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = panel.hidden;
      $$('[data-loc] .loc__panel').forEach(function (p) { p.hidden = true; });
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
      if (open) { var a = $('.loc__item.is-active', panel); if (a) a.scrollIntoView({ block: 'nearest' }); }
    });
    if (search) search.addEventListener('input', function () {
      var q = search.value.trim().toLowerCase();
      $$('.loc__item', panel).forEach(function (it) { it.parentElement.hidden = q && it.dataset.name.indexOf(q) === -1; });
    });
    document.addEventListener('click', function (e) { if (!loc.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });

  /* Copy discount code after newsletter signup */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    (navigator.clipboard ? navigator.clipboard.writeText(b.dataset.copy) : Promise.reject()).then(function () { toast('Code copied!'); }, function () {});
  });

  /* Free shipping bar: correct the threshold when the customer shops in a converted currency */
  function syncShipBars() {
    var rate = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    if (!rate || rate === 1) return;
    $$('[data-ship-bar]:not([data-ship-synced])').forEach(function (bar) {
      bar.setAttribute('data-ship-synced', '');  // mark first so our own DOM writes don't re-trigger
      if (bar.hasAttribute('data-ship-all-free')) return;  // every item ships free anyway
      var threshold = Math.round(parseInt(bar.dataset.threshold, 10) * rate);
      var total = parseInt(bar.dataset.total, 10), remaining = threshold - total;
      var fill = $('[data-ship-fill]', bar), text = $('[data-ship-text]', bar);
      fill.style.width = Math.min(100, total * 100 / threshold) + '%';
      bar.classList.toggle('is-unlocked', remaining <= 0);
      text.innerHTML = remaining > 0
        ? "You're only <strong>" + formatMoney(remaining) + '</strong> away from <strong>FREE SHIPPING</strong> 🚀'
        : "🎉 Congrats! You've unlocked <strong>FREE SHIPPING</strong>";
    });
  }
  syncShipBars();
  // Cart drawer re-renders replace the bar, so re-sync only when a fresh (unsynced) bar appears.
  new MutationObserver(function () { if ($('[data-ship-bar]:not([data-ship-synced])')) syncShipBars(); })
    .observe(document.body, { childList: true, subtree: true });

  /* Cart upsell: pick Style/Size and add without leaving the cart */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-upsell-option]');
    if (!sel) return;
    var form = sel.closest('[data-upsell-form]');
    var variants = JSON.parse($('[data-upsell-variants]', form).textContent);
    var opts = [];
    $$('[data-upsell-option]', form).forEach(function (s) { opts[parseInt(s.dataset.upsellOption, 10)] = s.value; });
    var v = variants.find(function (x) { return x.o.every(function (o, i) { return o === opts[i]; }); });
    var btn = $('.upsell__add', form);
    if (v) {
      $('[data-upsell-variant]', form).value = v.id;
      $('.upsell__price', form).firstChild.textContent = formatMoney(v.p) + ' ';
    }
    btn.disabled = !v || !v.a;
    btn.textContent = !v ? 'Unavailable' : (v.a ? '+ Add' : 'Sold out');
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-upsell-form]');
    if (!form) return;
    e.preventDefault();
    var btn = $('.upsell__add', form);
    btn.classList.add('is-loading'); btn.disabled = true;
    var fd = new FormData(form);
    var onPage = !!$('[data-cart-page]');
    if (!onPage) { fd.append('sections', 'cart-drawer'); fd.append('sections_url', window.location.pathname); }
    Cart.request(theme.routes.cartAdd + '.js', fd).then(function (item) {
      if (onPage) { window.location.reload(); return; }
      Cart.renderDrawer(item.sections && item.sections['cart-drawer']);
      Cart.updateCount();
    }).catch(function (err) {
      btn.classList.remove('is-loading'); btn.disabled = false;
      toast((err && (err.description || err.message)) || 'Could not add to cart');
    });
  });

  /* Team strip (landing): pick a team without reloading, then jump to the buy box */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-team-strip] [data-team]');
    if (!a) return;
    var strip = a.closest('[data-team-strip]');
    var fs = document.querySelector('[data-variant-picker] .option[data-option-index="' + strip.dataset.optionIndex + '"]');
    var input = fs && [].slice.call(fs.querySelectorAll('[data-option-input]')).find(function (i) { return i.value === a.dataset.team; });
    if (!input) return;          // fall back to the plain link
    e.preventDefault();
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    var top = document.querySelector('[data-product]');
    if (top) top.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* Landing CTA buttons jump back to the buy box */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-scroll-buy]');
    if (!b) return;
    var target = document.querySelector('[data-variant-picker]') || document.querySelector('[data-product]');
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* Live viewers counter – drifts up/down within [min, max] at random intervals */
  $$('[data-viewers]').forEach(function (el) {
    var min = parseInt(el.dataset.min, 10), max = parseInt(el.dataset.max, 10);
    if (max < min) { var t = min; min = max; max = t; }
    var out = $('[data-viewers-count]', el);
    var n = Math.floor(min + Math.random() * (max - min + 1));
    out.textContent = n;
    function tick() {
      var step = Math.floor(Math.random() * 4) + 1;          // 1-4 people
      var dir = Math.random() < 0.5 ? -1 : 1;
      if (n - step < min) dir = 1;
      if (n + step > max) dir = -1;
      n = Math.min(max, Math.max(min, n + dir * step));
      out.classList.add('is-changing');
      setTimeout(function () { out.textContent = n; out.classList.remove('is-changing'); }, 250);
      setTimeout(tick, 3000 + Math.random() * 4000);           // every 3-7s
    }
    setTimeout(tick, 3000 + Math.random() * 3000);
  });

  /* Shipping ETA timeline – counts from the customer's today */
  $$('[data-ship-eta]').forEach(function (el) {
    var business = el.dataset.business === 'true';
    function addDays(n) {
      var d = new Date();
      d.setHours(12, 0, 0, 0);
      var added = 0;
      while (added < n) {
        d.setDate(d.getDate() + 1);
        if (!business || (d.getDay() !== 0 && d.getDay() !== 6)) added++;
      }
      return d;
    }
    var fmt = function (d, opts) { return d.toLocaleDateString('en-US', opts); };
    function range(a, b) {
      var from = addDays(a), to = addDays(b);
      if (a === b) return fmt(from, { month: 'short', day: 'numeric' });
      var sameMonth = from.getMonth() === to.getMonth();
      return fmt(from, { month: 'short', day: 'numeric' }) + ' - ' + (sameMonth ? to.getDate() : fmt(to, { month: 'short', day: 'numeric' }));
    }
    var n = function (k) { return parseInt(el.dataset[k], 10) || 0; };
    $('[data-eta="placed"]', el).textContent = fmt(new Date(), { month: 'short', day: 'numeric' });
    $('[data-eta="shipped"]', el).textContent = range(n('shipMin'), n('shipMax'));
    $('[data-eta="delivered"]', el).textContent = range(n('deliverMin'), n('deliverMax'));
  });

  /* Holiday order deadline – hidden unless the customer can still get it in time.
     data-holiday is "MM-DD" or several "MM-DD|Name" joined by commas; the nearest cutoff still ahead wins ([event] = its name). */
  $$('[data-holiday-deadline]').forEach(function (el) {
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var days = parseInt(el.dataset.days, 10) || 0, pick = null;
    (el.dataset.holiday || '').split(',').forEach(function (item) {
      var parts = item.split('|'), md = parts[0].trim().split('-').map(Number);
      if (md.length !== 2 || !md[0] || !md[1]) return;
      var cutoff = new Date(today.getFullYear(), md[0] - 1, md[1] - days);
      if (cutoff < today) return;
      if (!pick || cutoff < pick.cutoff) pick = { cutoff: cutoff, name: (parts[1] || '').trim() };
    });
    if (!pick) return;
    var daysLeft = Math.round((pick.cutoff - today) / 864e5);
    var date = pick.cutoff.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    var left = daysLeft === 0 ? 'Last day' : daysLeft === 1 ? '1 day' : daysLeft + ' days';
    $$('[data-holiday-text]', el).forEach(function (t) {
      t.textContent = t.dataset.holidayText.replace('[date]', date).replace('[days]', left).replace('[event]', pick.name);
    });
    el.hidden = false;
  });

  /* Sticky add to cart */
  $$('[data-sticky-atc]').forEach(function (bar) {
    var section = bar.closest('[data-product]');
    var mainBtn = section && $('[data-add-to-cart]', section);
    if (!mainBtn) { bar.remove(); return; }
    // Apps like Kaching Bundles render their own sticky add-to-cart; never show two bars.
    var appSticky = function () { return document.querySelector('[class*="kaching-bundles-sticky"], [data-app-sticky-atc]'); };
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0 && !appSticky();
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
    io.observe(mainBtn);
    $('[data-sticky-atc-btn]', bar).addEventListener('click', function () {
      mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { if (!mainBtn.disabled) mainBtn.click(); }, 450);
    });
  });

  /* ---------------- Product recommendations ---------------- */
  $$('[data-recommendations]').forEach(function (el) {
    if (el.children.length && el.querySelector('.card')) return;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* ---------------- Tabs ---------------- */
  $$('[data-tabs]').forEach(function (wrap) {
    var btns = $$('[data-tab]', wrap), panels = $$('[data-tab-panel]', wrap);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-selected', x === b); });
        panels.forEach(function (p) { p.hidden = p.dataset.tabPanel !== b.dataset.tab; });
      });
    });
  });

  /* ---------------- Slideshow ---------------- */
  $$('[data-slider]').forEach(function (slider) {
    var track = $('[data-slider-track]', slider);
    var dots = $$('.slideshow__dot', slider);
    var count = track.children.length;
    if (count < 2) return;
    var index = 0, timer;
    function go(i) { index = (i + count) % count; track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' }); }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); restart(); }); });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      index = i;
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
    }, { passive: true });
    function restart() {
      clearInterval(timer);
      if (slider.hasAttribute('data-autoplay-on')) timer = setInterval(function () { go(index + 1); }, (parseInt(slider.dataset.autoplay, 10) || 5) * 1000);
    }
    slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    slider.addEventListener('mouseleave', restart);
    restart();
  });

  /* ---------------- Collection sort & filters ---------------- */
  $$('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
  $$('[data-facets-form]').forEach(function (form) {
    var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };
    form.addEventListener('change', function (e) {
      if (!isDesktop() || e.target.type === 'number') return;
      submitFacets(form);
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); submitFacets(form); });
  });
  function submitFacets(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    window.location.href = form.getAttribute('action') + '?' + params.toString();
  }

  /* ---------------- Predictive search ---------------- */
  var searchModal = $('[data-search-modal]');
  if (searchModal) {
    var input = $('[data-search-input]', searchModal);
    var results = $('[data-search-results]', searchModal);
    var debounce;
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) {
        e.preventDefault();
        closeAll();
        searchModal.classList.add('is-open');
        searchModal.setAttribute('aria-hidden', 'false');
        overlay.hidden = false;
        lock(true);
        setTimeout(function () { input.focus(); }, 200);
      }
    });
    input.addEventListener('input', function () {
      clearTimeout(debounce);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      debounce = setTimeout(function () {
        fetch(theme.routes.predictiveSearch + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,query&resources[limit]=8&resources[options][fields]=title,product_type,variants.title,tag,vendor')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = data.resources.results;
            var html = '';
            if (res.queries && res.queries.length) {
              html += '<ul class="predictive__queries">' + res.queries.slice(0, 5).map(function (x) { return '<li><a href="' + x.url + '">' + x.styled_text + '</a></li>'; }).join('') + '</ul>';
            }
            if (res.products && res.products.length) {
              html += '<p class="predictive__heading">Products</p><ul class="predictive__list">' + res.products.map(function (p) {
                var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=300" alt="" loading="lazy">' : '';
                return '<li><a class="predictive__item" href="' + p.url + '">' + img + '<strong>' + p.title + '</strong><span>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></a></li>';
              }).join('') + '</ul>';
            } else {
              html += '<p>No products found for "' + q.replace(/</g, '&lt;') + '"</p>';
            }
            html += '<a class="predictive__all" href="' + theme.routes.search + '?type=product&q=' + encodeURIComponent(q) + '">View all results →</a>';
            results.innerHTML = html;
          }).catch(function () {});
      }, 250);
    });
  }
})();
